import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {featureInterface} from "./featureInterface";
import {getFeatureEditPermission, getFilteredFeatures} from "../featuresFunctions";
import {featuresSetupUpdateFeature, featuresSetupUpdateFeatures} from "../featuresActions";
import {UNIT_MEASUREMENTS} from "../../../utilities";
import {setQuestionPopupState} from "../../../actions/A_Popups";
import Select5 from "../../Generic/Select5";


const FeaturesSetupFeatureContentUnitSelect = (props) => {

  const {feature, intl, canEdit, allUnitMeasurementOptions, featuresSetupUpdateFeature, featuresSetupUpdateFeatures,
    setQuestionPopupState} = props;

  const onItemClick = (selectOption) => {
    if (!canEdit) {
      return false
    }
    setQuestionPopupState({
      showPopup: true,
      questionMessage: intl.formatMessage({id: "features.setup.applyUnitPopup"}),
      yesClick: () => {
        featuresSetupUpdateFeatures('uofM', selectOption.value);
      },
      noClick: () => {
        featuresSetupUpdateFeature(feature, 'uofM', selectOption.value);
      }
    })
  }

  const selectedItem = allUnitMeasurementOptions.find(item => item.value === feature.uofM);

  return (
    <Select5 selectItems={allUnitMeasurementOptions}
             selectItemClick={onItemClick}
             selectedItem={selectedItem}
             placeholder={intl.formatMessage({id: "features.setup.feature.placeholder.unit"})}
             className={"select5--units"}
             maxItems={6} />
  )
};

FeaturesSetupFeatureContentUnitSelect.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {canEdit} = getFeatureEditPermission(store);
  const featuresList = getFilteredFeatures(store, false, false);

  const allUnitMeasurementOptions = [...new Set([
    ...featuresList.filter(feature => feature && feature.uofM).map(feature => feature.uofM),
    ...UNIT_MEASUREMENTS
  ])].map(option => ({
    value: option,
    label: option
  }))

  return {
    canEdit,
    allUnitMeasurementOptions,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature,
  featuresSetupUpdateFeatures,
  setQuestionPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureContentUnitSelect)
)
